import React from 'react'
import { AcceptedReportSubmissionGroupsGrid } from './grids/acceptedReportSubmissionGroupsGrid'
import { DatasetGrid } from './grids/datasetGrid'
import { WhiteBox } from '@/components/Layout'
import { localized } from '@/decorators/localized'

@localized()
class OutputReportGeneratorContent extends React.Component {
  render () {
    const {
      outputReportGroupDefinition,
      onReportSubmissionGroupAdd,
      onReportSubmissionGroupsBulkAdd,
      onReportSubmissionGroupRemove,
      datasets,
      localize } = this.props
    if (outputReportGroupDefinition) {
      return (
        <div>
          <WhiteBox header={localize('Reporting.ReportSubmissionGroup')}>
            <AcceptedReportSubmissionGroupsGrid
              outputReportGroupDefinitionId={outputReportGroupDefinition.id}
              datasets={datasets}
              onReportSubmissionGroupAdd={onReportSubmissionGroupAdd}
              onReportSubmissionGroupsBulkAdd={onReportSubmissionGroupsBulkAdd}
            />
          </WhiteBox>
          {datasets.map(dataset => <DatasetGrid key={`dataset_grid_${dataset.index}`} dataset={dataset} onReportSubmissionGroupRemove={onReportSubmissionGroupRemove} />)}
        </div>
      )
    }
    return null
  }
}

export {
  OutputReportGeneratorContent
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/content.js